import { render, staticRenderFns } from "./SumarioDataTable.vue?vue&type=template&id=f467cd1e&scoped=true"
import script from "./SumarioDataTable.vue?vue&type=script&lang=js"
export * from "./SumarioDataTable.vue?vue&type=script&lang=js"
import style0 from "./SumarioDataTable.vue?vue&type=style&index=0&id=f467cd1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f467cd1e",
  null
  
)

export default component.exports